module.exports = __webpack_public_path__ + "h5/img/404.4d42434f.png";